(function schedulerHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};

  /**
 * @constructs NewHomeSource.SchedulerHandler
 */
  function SchedulerHandler() { }

  /**
   * Gets the google analytics tracker with the NHS id.
   */
  function getGoogleAnalyticsTracker() {
    if (typeof global.ga !== 'function' || typeof global.ga.getAll !== 'function') {
      return null;
    }

    let trackers = global.ga.getAll().filter(function (elem) {
      return elem.get('trackingId') === 'UA-40843711-4';
    });

    let googleAnalyticsTracker = trackers[0] ? trackers[0] : null;

    return googleAnalyticsTracker;
  }

  /**
   * Opens the modal with the custom scheduler
   * @param {any} element The html element that cointains the data attributes with the scheduler data.
   */
  const triggerGaEvent = function () {
    let googleAnalyticsTracker = getGoogleAnalyticsTracker();
    let id = null;

    if (googleAnalyticsTracker) {
      id = googleAnalyticsTracker.get('name');
    }

    global.ga && global.ga(id + '.send', 'event', 'Lead Events', 'TM Schedule Appt', 'Open Form');
  };

  /**
   * Hides or displays the date slider.
   * @param {boolean} display If the data slider should display or not.
   */
  SchedulerHandler.toggleMobileDateSliderForCustomScheduler = function (display) {
    const appointmentDateSlider = document.querySelector('[data-appointment-date-slider]');
    const selfGuidedDateSlider = document.querySelector('[data-self-guided-slider]');

    if (display) {
      if (selfGuidedDateSlider) {
        selfGuidedDateSlider.removeAttribute('hidden');
      }
    } else if (appointmentDateSlider) {
      appointmentDateSlider.setAttribute('hidden', '');
    }
  };

  /**
   * Opens a new tab with the scheduler url.
   * @param {any} element The html element that cointains the data attributes with the scheduler data.
   */
  SchedulerHandler.openSchedulerTab = function (element) {
    const schedulerUrl = element.dataset.schedulerUrl;

    triggerGaEvent();
    global.open(schedulerUrl, '_blank', 'noopener,noreferrer');
  };

  global.NewHomeSource.SchedulerHandler = SchedulerHandler;

  return SchedulerHandler;
}(window));
